import { lazy } from 'react';

// Informational Pages - 8 components
// Small pages (~440 lines total), rarely visited

export const About = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/About'
));

export const PrivacyPolicy = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/Privacy'
));

export const TermsAndconditions = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/Terms'
));

export const TermsAndconditionsDietCenter = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/TermsAndConditions/DietCenter'
));

export const Contact = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/Contact'
));

export const Support = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/Support'
));

export const DietitianAppointment = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/DietitianAppointment'
));

export const Onboarding = lazy(() => import(
  /* webpackChunkName: "static" */ '../../pages/Onboarding'
));
